import { useContext } from "react";

import type { IAuthContext } from "@/contexts/AuthContext";
import { AuthContext } from "@/contexts/AuthContext";

// NOTE: NSAI-6421 — the same context WITHOUT the provider guard below, for
// components that are shared with the admin panel. `/admin/*` is mounted
// outside `AuthProvider` (it runs on `AdminAuthProvider` instead), so a shared
// component that reaches for auth through `useAuth` takes the whole admin page
// down rather than losing one optional detail — which is what an admin chat
// transcript containing a diagram used to do. Only components that still
// render correctly signed-out belong here; anything that genuinely needs a
// user keeps `useAuth` and its guard.
export const useOptionalAuth = (): IAuthContext | undefined =>
  useContext(AuthContext);

export const useAuth = (): IAuthContext => {
  const context = useContext(AuthContext);

  // NOTE: this guard ensures the hook is used within its required provider and does not need test coverage.
  /* istanbul ignore next */
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
